import React from "react";
import { createRoot } from "reactdom";
import FeaturedVideo from "../FeaturedVideo";

// function called on frontend.js to render the video player

const renderFeaturedVideo =()=>{

	const featuredVideoElements = document.getElementsByClassName("js-video-player");
	
	if (featuredVideoElements) {
		Array.from(featuredVideoElements).forEach(function (video) {
			const root = createRoot(video);
			root.render(<FeaturedVideo {...video.dataset} />);
		});
	}
		
}

export default renderFeaturedVideo;